import Vue from 'vue'
import Vuex from 'vuex'
import { assign } from 'lodash'

Vue.use(Vuex)

/**
 * Import and define all of our modules for the store.
 */
import app from 'vx/modules/app'
import user from 'vx/modules/user'
import location from 'vx/modules/location'
import job from 'vx/modules/job'
import commodity from 'vx/modules/commodity'
import driver from 'vx/modules/driver'
import truck from 'vx/modules/truck'
import load from 'vx/modules/load'
import loadCheck from 'vx/modules/load-check'
import carrier from 'vx/modules/carrier'
import weighbridge from 'vx/modules/weighbridge'
import invoice from 'vx/modules/invoice'
import payment from 'vx/modules/payment'
import report from 'vx/modules/report'
import dashboard from 'vx/modules/dashboard'
import terms from 'vx/modules/terms'
import map from 'vx/modules/map'
import settings from 'vx/modules/settings'
import xero from 'vx/modules/xero'

const modules = {
  app,
  user,
  location,
  job,
  commodity,
  driver,
  truck,
  load,
  loadCheck,
  carrier,
  weighbridge,
  invoice,
  payment,
  report,
  dashboard,
  terms,
  map,
  settings,
  xero
}

/**
 * Create our store object.
 *
 * @type Vuex
 */
const store = new Vuex.Store({
  actions: {
    reset ({ commit }, state) {
      commit('reset', state)
    }
  },
  mutations: {
    reset (state, initialState) {
      assign(state, initialState)
    }
  },
  modules,
  strict: true
})

export { store, modules }
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js